import React from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import ImageUploader from '../Component/ImageUploader'

const ProductModal = ({
  show,
  handleClose,
  product,
  handleSave,
  categories,
}) => {
  const [formData, setFormData] = useState({
  ProductId: null,
  ProductName: "",
  ProductDesc: "",
  ProductPrice: "",
  DimensionsCm: "",
  DimensionsInch: "",
  PrimaryMaterial: "",
  Weight: "",
  DetailSpecifications: "",
  StorageType: "",
  ProductColor: "",
  SuperCategory: "",
  SubCategory: "",
  ProductImages: [],
  });
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  const handleSuperCategoryChange = useCallback(
    (superCategoryId, isInitial = false) => {
      setFormData((prev) => ({
        ...prev,
        SuperCategory: superCategoryId,
        SubCategory: "",
      }));

      const selectedCategory = categories.find(
        (cat) => cat.SuperCategoryId === Number(superCategoryId)
      );

      if (selectedCategory) {
      let validSubCategories = [];

      try {
        // Try to parse valid JSON first
        const parsed = JSON.parse(selectedCategory.SubCategories);
        validSubCategories = (parsed || []).filter(
          (sub) => sub.SubCategoryId !== null && sub.SubCategoryName !== null
        );
      } catch (err) {
        // Safe fallback parsing if string is broken
        const raw = selectedCategory.SubCategories
          .trim()
          .replace(/\\n/g, "")
          .replace(/\\"/g, '"')
          .replace(/\\'/g, "'")
          .replace(/\\\\/g, "\\");

        const matches = raw.match(/{[^{}]*}/g); // get individual objects
        if (matches) {
          try {
            validSubCategories = matches.map((obj) => JSON.parse(obj));
          } catch (innerErr) {
            console.warn("Parsing failed on one of the subcategory objects:", innerErr);
          }
        } else {
          console.warn("⚠️ No valid JSON objects in SubCategories:", raw);
        }
      }

      setFilteredSubCategories(validSubCategories);

      if (isInitial && product?.SubCategory) {
        setFormData((prev) => ({
          ...prev,
          SubCategory: product.SubCategory?.SubCategoryId || "",
        }));
      }
    } else {
      setFilteredSubCategories([]);
    }
  },
  [categories, product]
);

  useEffect(() => {
    if (product) {

setFormData({
  ProductId: product.ProductId || null,
  ProductName: product.ProductName || "",
  ProductDesc: product.ProductDesc || "",
  ProductPrice: product.ProductPrice || "",
  DimensionsCm: product.DimensionsCm || "",
  DimensionsInch: product.DimensionsInch || "",
  PrimaryMaterial: product.PrimaryMaterial || "",
  Weight: product.Weight || "",
  DetailSpecifications: product.DetailSpecifications || "",
  StorageType: product.StorageType || "",
  ProductColor: product.ProductColor || "",
  SuperCategory: product?.ProductCategory?.CategoryId || "",
  SubCategory: product?.SubCategory?.SubCategoryId || "",
  ProductImages: product.ProductImages
    ? typeof product.ProductImages === "string"
      ? JSON.parse(product.ProductImages)
      : product.ProductImages
    : [],
});

      // Load subcategories if a SuperCategory is already selected
      if (product?.ProductCategory?.CategoryId) {
        handleSuperCategoryChange(product?.ProductCategory?.CategoryId, true);
      }
    } else {
      // Reset form if in Add mode
     setFormData({
        ProductId: null,
        ProductName: "",
        ProductDesc: "",
        ProductPrice: "",
        DimensionsCm: "",
        DimensionsInch: "",
        PrimaryMaterial: "",
        Weight: "",
        DetailSpecifications: "",
        StorageType: "",
        ProductColor: "",
        SuperCategory: "",
        SubCategory: "",
        ProductImages: [],
      });
      setFilteredSubCategories([]);
    }
  }, [product, show, handleSuperCategoryChange]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = () => {
  const formDataToSend = new FormData();

  formDataToSend.append("ProductId", formData.ProductId);
  formDataToSend.append("ProductName", formData.ProductName);
  formDataToSend.append("ProductDesc", formData.ProductDesc);
  formDataToSend.append("ProductPrice", formData.ProductPrice);
  formDataToSend.append("DimensionsCm", formData.DimensionsCm);
  formDataToSend.append("DimensionsInch", formData.DimensionsInch);
  formDataToSend.append("PrimaryMaterial", formData.PrimaryMaterial);
  formDataToSend.append("Weight", formData.Weight);
  formDataToSend.append("DetailSpecifications", formData.DetailSpecifications);
  formDataToSend.append("StorageType", formData.StorageType);
  formDataToSend.append("ProductColor", formData.ProductColor);
  formDataToSend.append("ProductCategory", formData.SuperCategory);
  formDataToSend.append("ProductSubCategory", formData.SubCategory);

  // ✅ Product images
  const productImagesArray = Array.isArray(formData.ProductImages)
    ? formData.ProductImages
    : formData.ProductImages
      ? [formData.ProductImages]
      : [];

  productImagesArray.forEach((image) => {
    if (image instanceof File) {
      formDataToSend.append("ProductImages", image); // new image
    } else if (typeof image === "string") {
      formDataToSend.append("ExistingImages", image); // existing Cloudinary URL
    }
  });

  // ✅ Editing
  const isEditing = !!formData.ProductId;

  if (isEditing) {
    const existingImages =
      typeof product?.ProductImages === "string"
        ? JSON.parse(product.ProductImages)
        : product?.ProductImages || [];

const existingPublicIds =
  typeof formData.PublicIdList === "string"
    ? JSON.parse(formData.PublicIdList)
    : formData.PublicIdList || [];

formDataToSend.append("ExistingPublicIds", JSON.stringify(existingPublicIds));

    formDataToSend.append("OldProductImages", JSON.stringify(existingImages));
    formDataToSend.append("OldPublicIds", JSON.stringify(existingPublicIds));
  }

  handleSave(formDataToSend, isEditing);
  handleClose();
};


  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{product ? "Edit Product" : "Add Product"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Super Category dropdown */}
          <Form.Group className="mb-3">
            <Form.Label>Super Category</Form.Label>
            <Form.Select
              name="SuperCategory"
              value={formData.SuperCategory || ""}
              onChange={(e) => handleSuperCategoryChange(e.target.value)}
            >
              <option value="">Select Super Category</option>
              {categories.map((category) => (
                <option
                  key={category.SuperCategoryId}
                  value={category.SuperCategoryId}
                >
                  {category.SuperCategoryName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Subcategory dropdown (only if Super Category has subcategories) */}
          {filteredSubCategories.length > 0 && (
            <Form.Group className="mb-3">
              <Form.Label>Sub Category</Form.Label>
              <Form.Select
                name="SubCategory"
                value={formData.SubCategory || ""}
                onChange={handleChange}
              >
                <option value="">Select Sub Category</option>
                {filteredSubCategories.map((sub) => (
                  <option key={sub.SubCategoryId} value={sub.SubCategoryId}>
                    {sub.SubCategoryName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Product Name</Form.Label>
            <Form.Control
              type="text"
              name="ProductName"
              placeholder="Enter product name"
              value={formData.ProductName}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={2} // Adjust the number of rows to make it taller
              name="ProductDesc"
              placeholder="Enter product description"
              value={formData.ProductDesc}
              onChange={handleChange}
            />
            <Form.Text className="text-muted">
              You can separate different descriptions with a period.
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Price</Form.Label>
            <Form.Control
              type="text"
              name="ProductPrice"
              placeholder="Enter product price"
              value={formData.ProductPrice}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Dimensions (cm)</Form.Label>
            <Form.Control
              as="textarea"
              rows={2} // Adjust the number of rows to make it taller
              name="DimensionsCm"
              value={formData.DimensionsCm}
              onChange={handleChange}
              placeholder="e.g. 120x60x40 cm"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Dimensions (inch)</Form.Label>
            <Form.Control
              as="textarea"
              rows={2} // Adjust the number of rows to make it taller
              name="DimensionsInch"
              value={formData.DimensionsInch}
              onChange={handleChange}
              placeholder="e.g. 47x24x16 inch"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Primary Material</Form.Label>
            <Form.Control
              as="textarea"
              rows={2} // Adjust the number of rows to make it taller
              name="PrimaryMaterial"
              value={formData.PrimaryMaterial}
              onChange={handleChange}
              placeholder="e.g. Wood, Metal"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Weight</Form.Label>
            <Form.Control
              as="textarea"
              rows={2} // Adjust the number of rows to make it taller
              name="Weight"
              value={formData.Weight}
              onChange={handleChange}
              placeholder="Enter weight"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Detail Specifications</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              name="DetailSpecifications"
              value={formData.DetailSpecifications}
              onChange={handleChange}
              placeholder="Enter detailed specifications"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Storage Type</Form.Label>
            <Form.Control
              as="textarea"
              rows={2} // Adjust the number of rows to make it taller
              name="StorageType"
              value={formData.StorageType}
              onChange={handleChange}
              placeholder="e.g. With Drawers, Open Shelf"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Product Color</Form.Label>
            <Form.Control
              as="textarea"
              rows={2} // Adjust the number of rows to make it taller
              name="ProductColor"
              value={formData.ProductColor}
              onChange={handleChange}
              placeholder="Enter product color"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Product Images</Form.Label>
            <ImageUploader
              images={formData.ProductImages}
              setImages={(updatedImages) => {
                setFormData((prev) => {
                  // Ensure deleted images are removed while keeping both old & new ones
                  return {
                    ...prev,
                    ProductImages: updatedImages, // This directly reflects the updated images
                  };
                });
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {product ? "Update Product" : "Add Product"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductModal;
